module.exports = __webpack_public_path__ + "img/mos-swiper-pad3.a69e9d12.png";